<template>
    <div class="card"
         :style="{'width': width}"
         v-on:mouseenter="over = true"
         v-on:mouseleave="over = false"
         style="margin-bottom: 10px; position: relative;"
         :class="{'shadow': over}">

        <img :id="'img_' + id"
             class="image"
             v-if="show_image"
             :src="image_source == 'none'?image_source:'./src/assets.logo.png'"
             style="width: 100%; z-index: 1;"
             v-bind:style="{'height': image_height}">
        <div v-if="show_sharing" style="position: absolute; top: 10px; right: 10px; z-index: 2;">
            <i class="fas fa-share-alt-square"></i>
        </div>

        <div style="position: relative">
            <div class="popup" v-show="over"
                 style="position: absolute; top: -46px; width: 100%; min-height: 40px; background: white; opacity: .7; padding: 4px;">
                <div class="d-flex flex-row justify-content-between">
                    <div>
                        <div v-if="show_count_of_joined">
                            <i class="fas fa-users" style="font-size: 1.4rem; margin-right: 4px;"></i>
                            <span class="text-muted">
                                {{count_of_joined}}
                            </span>
                        </div>
                    </div>
                    <ks-button v-if="button_action === 'add_to_cart'" :label="button_text" @onClick="onClick()"></ks-button>
                    <router-link v-else-if="button_action === 'go_to_products_url'" class="nav-link" :to="{ path: product_url}">
                        <ks-button :label="button_text"></ks-button>
                    </router-link>
                </div>
            </div>
            <div class="percent-joined" style="position: relative">
                <div v-if="show_percent_joined" style="height: 10px;"
                     :class="{'green': percent_joined == 100, 'yellow': percent_joined < 100}"
                     :style="{'width': percent_joined + '%'}"></div>
            </div>
            <div style="padding: 5px;">
                <div style="width: 100%" v-if="show_campaign"><h6 class="text-muted">{{campaign}}</h6></div>
                <div class="d-flex flex-row justify-content-between" style="width: 100%">
                    <div v-if="show_name">
                        <h4>{{name}}</h4>
                    </div>
                    <div v-if="show_product_name">
                        <h4>{{product_name}}</h4>
                    </div>
                    <div v-if="show_cost">
                        <h4>${{cost}}</h4>
                    </div>
                </div>
                <div v-show="show_subtitle">
                    <h5 class="text-muted">{{subtitle}}</h5>
                </div>
                <div class="d-flex flex-row justify-content-between" style="width: 100%">
                    <div v-if="show_end_date">
                        <h5>{{format_date(end_date)}}</h5>
                    </div>
                    <div v-if="show_views">
                        <h6 style="color: gray;">views: {{views}}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import KsButton from "../button/index";
    import format_date from "../../mixins/formatDate";

    export default {
        /**
            tag
            name: ks-product-card
            description: product card
        **/
        name: "product_card",
        components: {KsButton},
        props: {
            /**
                attribute
                name: id 
                description: id
            **/
            id: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: height 
                description: height
            **/
            height: {
                type: String,
                default: "auto"
            },
            /**
                attribute
                name: image_height 
                description: image_height
            **/
            image_height: {
                type: String,
                default: "300px"
            },
            /**
                attribute
                name: count_of_joined 
                description: count_of_joined
            **/
            count_of_joined: {
                type: Number,
                default: 0
            },
            /**
                attribute
                name: show_count_of_joined 
                description: show_count_of_joined
            **/
            show_count_of_joined: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: image_source 
                description: image_source
            **/
            image_source: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_image 
                description: show_image
            **/
            show_image: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: button_text 
                description: button_text
            **/
            button_text: {
                type: String,
                default: "Add"
            },
            /**
                attribute
                name: percent_joined 
                description: percent_joined
            **/
            percent_joined: {
                type: Number,
                default: 0
            },
            /**
                attribute
                name: show_percent_joined 
                description: show_percent_joined
            **/
            show_percent_joined: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: cost 
                description: cost
            **/
            cost: {
                type: String,
                default: '0.00'
            },
            /**
                attribute
                name: show_cost 
                description: show_cost
            **/
            show_cost: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: name 
                description: name
            **/
            name: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_name 
                description: show_name
            **/
            show_name: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: campaign 
                description: campaign
            **/
            campaign: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_campaign 
                description: show_campaign
            **/
            show_campaign: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: end_date 
                description: end_date
            **/
            end_date: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_end_date 
                description: show_end_date
            **/
            show_end_date: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: views 
                description: views
            **/
            views: {
                type: Number,
                default: 0
            },
            /**
                attribute
                name: show_views 
                description: show_views
            **/
            show_views: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: show_sharing 
                description: show_sharing
            **/
            show_sharing: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: subtitle 
                description: subtitle
            **/
            subtitle: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_subtitle 
                description: show_subtitle
            **/
            show_subtitle: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: product_name 
                description: product_name
            **/
            product_name: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_product_name 
                description: show_product_name
            **/
            show_product_name: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: button_action 
                description: button_action
            **/
            button_action: { type: String, default: "add_to_cart" }, // add_to_cart, go_to_products_url
            /**
                attribute
                name: product_url 
                description: product_url
            **/
            product_url: { type: String, default: null }
        },
        mixins: [format_date],
        methods: {
            onClick() {
                this.$emit('onClick', this.id);
            }
        },
        data: function () {
            return {
                over: false,
            }
        },
        computed: {
            width() {
                let return_var = "32%";
                if (this.show_left && this.show_right) {
                    return_var = "50%";
                }
                if (!this.show_left && this.show_right || this.show_left && !this.show_right) {
                    return_var = "33%";
                }
                if (!this.show_left && !this.show_right) {
                    return_var = "25%";
                }
                return return_var;
            },
            show_left() {
                return app.store.state.ks_app.layout_store.show_left_block;
            },
            show_right() {
                return app.store.state.ks_app.layout_store.show_right_block;
            },

        }
    }
</script>
<style>
    .green {
        background: green;
    }

    .yellow {
        background: yellow;
    }
</style>
